export const ACTIVITY_CENTRE_TABS = ['processing', 'completed'] as const;

export type ActivityCentreTab = (typeof ACTIVITY_CENTRE_TABS)[number];

export const ACTIVITY_CENTRE_SHEET_WIDTH = '640px';

// Scrollbar per Figma node 10931:136591:
//   18px (spacing-6) total gutter (off-white track)
//   6px pill thumb (dinnerplate-white) centered via a 6px off-white padding
//   border — same token/border-trick pattern as searchable-dropdown. No
//   borderWidth token equals 6px in the grain scale (only 0.5 / 1 / 2), so
//   the 6 stays arbitrary.
export const CUSTOM_SCROLLBAR_CLASSES =
  '[&::-webkit-scrollbar]:w-6 ' +
  '[&::-webkit-scrollbar-track]:bg-off-white ' +
  '[&::-webkit-scrollbar-thumb]:rounded-full ' +
  '[&::-webkit-scrollbar-thumb]:border-[6px] ' +
  '[&::-webkit-scrollbar-thumb]:border-solid ' +
  '[&::-webkit-scrollbar-thumb]:border-off-white ' +
  '[&::-webkit-scrollbar-thumb]:bg-dinnerplate-white';
